import { CheckCircle2, Circle, ArrowRight, ShieldCheck, Sparkles } from "lucide-react";
import { Button } from "../ui/button";

export const buildChecklist = (page) => [
  { id: "texts", label: "Texte geschrieben", done: true },
  { id: "images", label: "Bilder ausgewählt", done: true },
  { id: "design", label: "Design & SEO vorbereitet", done: true },
  { id: "logo", label: "Logo hinzufügen", done: !!page?.logo_url, action: "logo" },
  { id: "publish", label: "Domain wählen & veröffentlichen", done: false, action: "publish" },
];

const AFTER_PURCHASE = ["Alle Texte & Leistungen", "Bilder & eigene Fotos", "Logo & Kontaktdaten", "Google-Bewertungen & Kundenstimmen"];

const ChecklistItem = ({ item, onAction }) => (
  <li>
    <button
      type="button"
      disabled={item.done || !item.action}
      onClick={() => onAction(item.action)}
      className="flex w-full items-center gap-3 rounded-lg px-2 py-1.5 text-left text-sm transition-colors enabled:hover:bg-indigo-50"
      data-testid={`cro-check-${item.id}`}
    >
      {item.done ? <CheckCircle2 className="h-5 w-5 flex-shrink-0 text-emerald-500" /> : <Circle className="h-5 w-5 flex-shrink-0 text-slate-300" />}
      <span className={item.done ? "text-slate-500 line-through decoration-slate-300" : "font-medium text-slate-900"}>{item.label}</span>
    </button>
  </li>
);

export const progressOf = (page) => (page?.logo_url ? 90 : 80);

const ProgressBar = ({ percent }) => (
  <div className="h-2 w-full overflow-hidden rounded-full bg-slate-100">
    <div className="h-full rounded-full bg-gradient-to-r from-emerald-400 to-indigo-600 transition-[width] duration-700" style={{ width: `${percent}%` }} data-testid="cro-progress-bar" />
  </div>
);

export const ConversionPanel = ({ page, onAction, onPublish }) => {
  const items = buildChecklist(page);
  const percent = progressOf(page);
  return (
    <aside className="hidden w-80 flex-shrink-0 flex-col gap-4 overflow-y-auto lg:flex" data-testid="cro-panel">
      <div className="rounded-2xl bg-white p-5 shadow-sm ring-1 ring-slate-200">
        <div className="mb-2 flex items-baseline justify-between">
          <h3 className="font-semibold text-slate-900">Ihre Seite ist fast fertig</h3>
          <span className="text-sm font-bold tabular-nums text-indigo-600" data-testid="cro-progress-percent">{percent} %</span>
        </div>
        <ProgressBar percent={percent} />
        <ul className="mt-4 space-y-0.5">{items.map((i) => <ChecklistItem key={i.id} item={i} onAction={onAction} />)}</ul>
        <Button onClick={onPublish} className="mt-4 h-11 w-full rounded-full bg-indigo-600 hover:bg-indigo-700" data-testid="cro-publish-btn">
          Jetzt veröffentlichen <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      </div>

      <div className="rounded-2xl bg-white p-5 shadow-sm ring-1 ring-slate-200">
        <div className="mb-3 flex items-center gap-2 font-semibold text-slate-900">
          <Sparkles className="h-4 w-4 text-indigo-600" /> Nach dem Kauf jederzeit änderbar
        </div>
        <ul className="space-y-2">
          {AFTER_PURCHASE.map((t) => (
            <li key={t} className="flex items-center gap-2 text-sm text-slate-700"><CheckCircle2 className="h-4 w-4 text-indigo-500" />{t}</li>
          ))}
        </ul>
        <p className="mt-4 flex items-start gap-2 text-xs text-slate-500">
          <ShieldCheck className="mt-0.5 h-4 w-4 flex-shrink-0 text-emerald-500" /> Monatlich kündbar – Ihre Seite gehört Ihnen.
        </p>
      </div>
    </aside>
  );
};

export const MobileConversionBar = ({ page, onPublish }) => {
  const percent = progressOf(page);
  return (
    <div className="flex-shrink-0 border-t border-slate-200 bg-white px-4 py-3 lg:hidden" data-testid="cro-mobile-bar">
      <div className="mb-2 flex items-center justify-between text-xs">
        <span className="font-medium text-slate-700">Seite zu {percent} % fertig · nach dem Kauf alles änderbar</span>
      </div>
      <div className="flex items-center gap-3">
        <div className="flex-1"><ProgressBar percent={percent} /></div>
        <Button onClick={onPublish} size="sm" className="rounded-full bg-indigo-600 hover:bg-indigo-700" data-testid="cro-mobile-publish-btn">
          Veröffentlichen
        </Button>
      </div>
    </div>
  );
};
